module.exports = __webpack_public_path__ + "static/img/function_1.7453c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/function_1.png
// module id = I5oG
// module chunks = 1